import { Inject, Injectable } from '@angular/core';
import { HttpResponse, HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoaderService } from 'src/app/extensions/services/loader.service';
import { ENV_CONFIG } from '../injection.token';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];

  constructor(
    private _loaderService: LoaderService,
    @Inject(ENV_CONFIG) private _config: env.EnvData
  ) {}

  removeRequest(req: HttpRequest<any>) {
    const index = this.requests.indexOf(req);
    if (index >= 0) {
      this.requests.splice(index, 1);
    }
    this._loaderService.isLoading.next(this.requests?.some(x => x) ?? false);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //loader not available if authority is challange to bypass loader display on session checks for silent-refresh token
    if (req.url.includes(this._config.ISSUER))
      return new Observable(observer => {
        const subscription = next.handle(req).subscribe(
          event => {
            observer.next(event);
          },
          err => {
            observer.error(err);
          },
          () => {
            observer.complete();
          }
        );
        return () => {
          subscription.unsubscribe();
        };
      });

    this.requests.push(req);

    this._loaderService.isLoading.next(true);
    return new Observable(observer => {
      const subscription = next.handle(req).subscribe(
        event => {
          if (event instanceof HttpResponse) {
            this.removeRequest(req);
            observer.next(event);
          }
        },
        err => {
          this.removeRequest(req);
          observer.error(err);
        },
        () => {
          this.removeRequest(req);
          observer.complete();
        }
      );
      return () => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };
    });
  }
}
